(function () {
  // =============================
  // CONFIG
  // =============================
  const DREAMS_UPSELL_VARIANT_ID = 47783969685674;
  const BALANCE_UPSELL_VARIANT_ID = 47783969783978;

  const IMG_BALANCE = "https://gomilovers.com/cdn/shop/files/429x342_Gomibalance_1.png";
  const IMG_DREAMS = "https://gomilovers.com/cdn/shop/files/429x342_Gomidreams_1.png";

  // ✅ These are TRIGGER VARIANT IDS (main variants that unlock offer)
  const TRIGGER_VARIANT_IDS = [
    47445212954794,
    47445212987562,
    47445213020330,
    47433986605226,
    47433986637994,
    47433986670762,
  ];

  // ✅ Main variants that should offer BALANCE
  const OFFER_BALANCE_FOR_MAIN_VARIANTS = new Set([
    47445212954794,
    47445212987562,
    47445213020330,
  ]);

  // Upsell variants that must not remain alone
  const UPSELL_VARIANT_IDS = [DREAMS_UPSELL_VARIANT_ID, BALANCE_UPSELL_VARIANT_ID];

  // =============================
  // STATE
  // =============================
  let upsellInProgress = false;
  let chosenUpsellVariantId = null;
  let flowMode = "cart"; // cart | checkout
  let lastClickTarget = null;

  // ✅ Track which main variant user selected
  let lastSelectedMainVariantId = null;

  // Enforcement state
  let enforcing = false;
  let lastCartSig = "";

  const $ = (s) => document.querySelector(s);

  // =============================
  // HELPERS
  // =============================
  const toNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };

  function upsellForMainVariant(mainVariantId) {
    if (OFFER_BALANCE_FOR_MAIN_VARIANTS.has(mainVariantId)) {
      return BALANCE_UPSELL_VARIANT_ID;
    }
    return DREAMS_UPSELL_VARIANT_ID;
  }

  async function getCart() {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    if (!r.ok) throw new Error("Failed cart.js");
    return await r.json();
  }

  function cartSignature(cart) {
    // A simple signature to know when cart changed (variant_id:qty)
    if (!cart?.items?.length) return "empty";
    return cart.items
      .map((it) => `${toNum(it.variant_id)}:${it.quantity}`)
      .sort()
      .join("|");
  }

  function cartHasTriggerVariant(cart) {
    if (!cart?.items?.length) return false;
    return cart.items.some((it) => TRIGGER_VARIANT_IDS.includes(toNum(it.variant_id)));
  }

  function cartHasUpsell(cart) {
    if (!cart?.items?.length) return false;
    return cart.items.some((it) => UPSELL_VARIANT_IDS.includes(toNum(it.variant_id)));
  }

  function whichUpsellsInCart(cart) {
    if (!cart?.items?.length) return [];
    const found = new Set();
    cart.items.forEach((it) => {
      const vid = toNum(it.variant_id);
      if (UPSELL_VARIANT_IDS.includes(vid)) found.add(vid);
    });
    return Array.from(found);
  }

  function getSelectedVariantIdFromClickTarget(target) {
    const form =
      target?.closest?.('form[action^="/cart/add"]') ||
      document.querySelector('form[action^="/cart/add"]');

    if (!form) return null;

    // Try FormData first (covers selects, radios, hidden input)
    try {
      const fd = new FormData(form);
      const id = toNum(fd.get("id"));
      if (id) return id;
    } catch (_) {}

    // Fallback: common Shopify input patterns
    const input = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');

    if (!input) return null;
    return toNum(input.value);
  }

  async function addUpsellVariant(variantId) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    if (!res.ok) {
      const t = await res.text();
      throw new Error("Upsell add failed: " + t);
    }
  }

  async function addMainProductBuyNow() {
    const form =
      lastClickTarget?.closest?.('form[action^="/cart/add"]') ||
      document.querySelector('form[action^="/cart/add"]');

    if (!form) return;

    const res = await fetch("/cart/add.js", {
      method: "POST",
      body: new FormData(form),
      credentials: "same-origin",
    });

    if (!res.ok) throw new Error("Main product add failed");
  }

  function goCheckoutSafely() {
    window.location.assign("/checkout");
  }

  // =============================
  // VISUAL FEEDBACK
  // =============================
  function pulseCartIcon() {
    const el =
      document.querySelector("#cart-icon-bubble") ||
      document.querySelector(".header__icon--cart") ||
      document.querySelector(".cart-count-bubble");

    if (!el) return;

    el.classList.remove("pcu-cart-pulse");
    void el.offsetWidth;
    el.classList.add("pcu-cart-pulse");
  }

  function showToast(message) {
    let toast = document.getElementById("pcu-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "pcu-toast";
      toast.className = "pcu-toast";
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add("show");
    setTimeout(() => toast.classList.remove("show"), 2200);
  }

  // =============================
  // MODAL
  // =============================
  function openModal() {
    const overlay = $("#precheckout-upsell-overlay");
    if (!overlay) return;
    overlay.hidden = false;
    document.documentElement.style.overflow = "hidden";
  }

  function closeModal() {
    const overlay = $("#precheckout-upsell-overlay");
    if (!overlay) return;
    overlay.hidden = true;
    document.documentElement.style.overflow = "";
  }

  function setModalContentByMainVariant(mainVariantId) {
    const nameEl = $("#pcu-product-name");
    const noteEl = $("#pcu-note");
    const imgEl = $("#pcu-product-image");

    if (!nameEl || !noteEl || !imgEl) return;

    const offerVariantId = upsellForMainVariant(mainVariantId);
    chosenUpsellVariantId = offerVariantId;

    if (offerVariantId === BALANCE_UPSELL_VARIANT_ID) {
      nameEl.textContent = "Gomi Balance";
      noteEl.textContent = "Agrega Gomi Balance con 40% de descuento.";
      imgEl.src = IMG_BALANCE;
      imgEl.alt = "Gomi Balance";
    } else {
      nameEl.textContent = "Gomi Dreams";
      noteEl.textContent = "Agrega Gomi Dreams con 40% de descuento.";
      imgEl.src = IMG_DREAMS;
      imgEl.alt = "Gomi Dreams";
    }
  }

  // =============================
  // ✅ ENFORCEMENT (MOST RELIABLE)
  // Remove upsell variants if NO trigger variants exist
  // Uses /cart/update.js by VARIANT ID
  // =============================
  async function removeUpsellsByVariantIds(variantIds) {
    const updates = {};
    variantIds.forEach((vid) => {
      updates[String(vid)] = 0; // Shopify expects keys as strings
    });

    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ updates }),
    });

    if (!res.ok) {
      const t = await res.text();
      throw new Error("Cart update failed: " + t);
    }
    return await res.json();
  }

  async function enforceUpsellRule(reason = "") {
    if (enforcing) return;
    enforcing = true;

    try {
      const cart = await getCart();
      const sig = cartSignature(cart);

      // Avoid re-running if cart hasn't changed
      if (sig === lastCartSig) return;
      lastCartSig = sig;

      const hasTrigger = cartHasTriggerVariant(cart);
      const hasUps = cartHasUpsell(cart);

      // If no trigger but upsell exists => remove upsell(s)
      if (!hasTrigger && hasUps) {
        const upsells = whichUpsellsInCart(cart);
        await removeUpsellsByVariantIds(upsells);

        showToast("La oferta se eliminó porque ya no tienes el producto principal.");
        // Refresh page so UI matches (drawer/cart page)
        setTimeout(() => window.location.reload(), 700);
      }
    } catch (e) {
      // Keep silent except console; never block customer
      console.error("Upsell enforcement error", reason, e);
    } finally {
      enforcing = false;
    }
  }

  // =============================
  // CORE UPSELL FLOW
  // =============================
  async function startUpsellFlow(mode) {
    if (upsellInProgress) return;
    upsellInProgress = true;
    flowMode = mode;

    try {
      // Determine selected main variant NOW (from click-time form)
      let mainVid = lastSelectedMainVariantId;

      if (mode === "checkout") {
        await addMainProductBuyNow();
      }

      // If we couldn't read it from the form, fallback to cart trigger detection
      if (!mainVid) {
        const cart = await getCart();
        const foundTrigger = cart?.items?.find((it) =>
          TRIGGER_VARIANT_IDS.includes(toNum(it.variant_id))
        );
        mainVid = toNum(foundTrigger?.variant_id);
      }

      if (!mainVid) {
        // If somehow we can’t detect, don’t break checkout/cart
        upsellInProgress = false;
        if (mode === "checkout") goCheckoutSafely();
        return;
      }

      // ✅ Only show modal if selected/main variant is a trigger
      if (!TRIGGER_VARIANT_IDS.includes(mainVid)) {
        upsellInProgress = false;
        if (mode === "checkout") goCheckoutSafely();
        return;
      }

      setModalContentByMainVariant(mainVid);
      openModal();
    } catch (e) {
      console.error(e);
      upsellInProgress = false;
      if (mode === "checkout") goCheckoutSafely();
    }
  }

  async function finalizeFlow(accepted) {
    closeModal();
    upsellInProgress = false;

    if (accepted && chosenUpsellVariantId) {
      try {
        await addUpsellVariant(chosenUpsellVariantId);
        pulseCartIcon();

        const label =
          chosenUpsellVariantId === DREAMS_UPSELL_VARIANT_ID ? "Gomi Dreams" : "Gomi Balance";

        showToast(`${label} agregado al carrito ✓`);

        // Refresh so UI definitely shows it
        setTimeout(() => window.location.reload(), 1200);
      } catch (e) {
        console.error(e);
      }
    }

    if (flowMode === "checkout") {
      setTimeout(goCheckoutSafely, 300);
    }
  }

  // =============================
  // EVENTS / HOOKS
  // =============================
  function bindModalEvents() {
    const accept = $("#pcu-accept");
    const decline = $("#pcu-decline");
    if (accept) accept.addEventListener("click", () => finalizeFlow(true));
    if (decline) decline.addEventListener("click", () => finalizeFlow(false));
  }

  function interceptButtons() {
    document.addEventListener(
      "click",
      (e) => {
        lastClickTarget = e.target;

        // ✅ Capture selected main variant
        lastSelectedMainVariantId = getSelectedVariantIdFromClickTarget(e.target);

        // BUY NOW
        const buyNow = e.target.closest(
          'button[name="buy_now"], button[formaction*="/checkout"], .shopify-payment-button button'
        );
        if (buyNow) {
          e.preventDefault();
          e.stopPropagation();
          startUpsellFlow("checkout");
          return;
        }

        // ADD TO CART
        const addToCart = e.target.closest(
          'button[name="add"], button[type="submit"][name="add"], button.product-form__submit'
        );
        if (addToCart && !addToCart.closest(".shopify-payment-button")) {
          // Prevent double behavior (some themes submit immediately)
          // We don't prevent default here because your flow is "cart mode" (no forced add).
          startUpsellFlow("cart");
        }

        // ✅ Enforce when customer tries to checkout from cart/drawer
        const checkoutBtn = e.target.closest(
          'a[href="/checkout"], button[name="checkout"], button[data-checkout]'
        );
        if (checkoutBtn) {
          setTimeout(() => enforceUpsellRule("checkout-click"), 50);
        }

        // ✅ Enforce after remove / quantity clicks (covers cart drawer controls)
        const maybeCartChange = e.target.closest("button, a");
        if (maybeCartChange) {
          setTimeout(() => enforceUpsellRule("click-fallback"), 350);
        }
      },
      true
    );
  }

  function observeCartDomChanges() {
    // Works for cart drawer updates that don't trigger events
    const root = document.body;
    const obs = new MutationObserver(() => {
      // Debounced enforcement
      clearTimeout(observeCartDomChanges._t);
      observeCartDomChanges._t = setTimeout(() => enforceUpsellRule("mutation"), 400);
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  function startSafetyPoll() {
    // If theme uses fetch updates without any detectable events, poll lightly
    // Only useful on cart page / pages where users modify cart
    const isCartContext =
      location.pathname.includes("/cart") ||
      document.querySelector("cart-drawer") ||
      document.querySelector("[data-cart-drawer]");

    if (!isCartContext) return;

    setInterval(() => enforceUpsellRule("poll"), 2000);
  }

  // =============================
  // INIT
  // =============================
  document.addEventListener("DOMContentLoaded", () => {
    bindModalEvents();
    interceptButtons();

    // Initial enforce (in case cart already has upsell only)
    enforceUpsellRule("init");

    // Watch DOM changes + safety poll
    observeCartDomChanges();
    startSafetyPoll();
  });
})();